/** Minimal client-side CSV export (no dependencies). */

function escapeCell(value: string | number): string {
  const s = String(value);
  return /[",\n]/.test(s) ? `"${s.replaceAll('"', '""')}"` : s;
}

/** Triggers a download of `rows` (first row = header) as a CSV file. */
export function downloadCsv(filename: string, rows: (string | number)[][]): void {
  const body = rows.map((r) => r.map(escapeCell).join(',')).join('\r\n');
  const blob = new Blob(['\ufeff' + body], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
